import { Checkbox, Form, Typography } from 'antd'
export const userAgreement = 'https://docs.wair.ac.cn/taichu/UserAgreement.html'
export const privacyPolicy = 'https://docs.wair.ac.cn/taichu/PrivacyPolicy.html'

export const Agreement = ({ defaultChecked = false }) => {
  return (
    <Form.Item
      name="agreement"
      initialValue={defaultChecked}
      valuePropName="checked"
      rules={[
        // {
        //   required: true,
        //   message: '请阅读并同意用户协议和隐私政策',
        // },

        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('请阅读并同意用户协议和隐私政策'))
          },
        }),
      ]}
    >
      <Checkbox defaultChecked={defaultChecked}>
        <span style={{ fontSize: '12px' }}>我已阅读并同意</span>
        <Typography.Link
          style={{ color: '#0047BA', fontSize: '12px' }}
          onClick={() => {
            window.open(userAgreement)
          }}
        >
          <span style={{ fontSize: '12px' }}> 用户协议</span>
        </Typography.Link>
        <span style={{ fontSize: '12px' }}> 和 </span>
        <Typography.Link
          style={{ color: '#0047BA', fontSize: '12px' }}
          onClick={() => {
            window.open(privacyPolicy)
          }}
        >
          隐私政策
        </Typography.Link>
      </Checkbox>
    </Form.Item>
  )
}

export const LoginByPhoneAgreement = ({ defaultChecked = false }) => {
  return (
    <Form.Item
      name="loginByPhoneAgreement"
      initialValue={defaultChecked}
      valuePropName="checked"
      rules={[
        ({ getFieldValue }) => ({
          validator(_, value) {
            // console.log('loginByPhoneAgreement value', value)
            if (value) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('请阅读并同意用户协议和隐私政策'))
          },
        }),
      ]}
      // style={{ marginBottom: '24px' }}
    >
      <Checkbox defaultChecked={defaultChecked} className="pb-6">
        <div className="absolute top-[2px] left-6 text-[12px]">
          <span>未注册手机号将自动注册，勾选即代表您同意并接受</span>
          <br />
          <Typography.Link
            style={{ color: '#0047BA', fontSize: '12px' }}
            onClick={() => {
              window.open(userAgreement)
            }}
          >
            用户协议
          </Typography.Link>
          <span> 和 </span>
          <Typography.Link
            style={{ color: '#0047BA', fontSize: '12px' }}
            onClick={() => {
              window.open(privacyPolicy)
            }}
          >
            隐私政策
          </Typography.Link>
        </div>
      </Checkbox>
    </Form.Item>
  )
}

export default Agreement
